<template>
  <div class="seal-container">
    <div @click="chooseSeal" class="seal" v-if="!isChoosed">
      <span class="sealIcon">+</span>
      <span>添加印章</span>
    </div>
    <div @click="chooseSeal" v-if="isChoosed" class="seal_choosed" :style="{
        left: posX ? posX + 'px' : 0,
        top: posY ? posY + 'px' : 0,
      }">
      <!--YBT2-1367 去除拖动印章功能 wangyuan 2022-3-9 -->
      <!-- <div class="move-deal" v-if="canDelete" @mousedown.stop="move($event)"></div> -->
      <img :src="seal.url ? seal.url : seal.sealBase64" alt="" class="sealImg" />
      <div @click.stop="deleteSeal" v-if="canDelete" v-show="showDelete" class="sealDeleteButton">
        删除
      </div>
    </div>

    <!-- <div
      class="move-div"
      v-for="(item, index) in sealInfoList"
      :key="item + index"
      :style="{
        left: item.posX ? item.posX + 'px' : posX + 'px',
        top: item.posY ? item.posY + 'px' : posY + 'px',
      }"
      @mouseover="mouseEnter(index)"
      @mouseleave="mouseleave(index)"
    >
      <div v-show="index === showIndex && item.newAdd" class="move-handle">
        <div class="delete-deal" @click="onDelete(item, index)"></div>
        <div class="move-deal" @mousedown="move($event, index)"></div>
      </div>
      <div v-if="item.lose" class="lose">失效</div>
      <img
        :src="item.url ? item.url : item.sealBase64"
        alt=""
        @click.self="checkSeal(item)"
      />
    </div> -->

    <seal-list ref="sealList" :show="showList" v-bind="{elecseal,esignature}" @choose-seal="choosed">
    </seal-list>
    <purpose-pc :show="showPurpose" @check-succ="checkSucc"></purpose-pc>
    <!-- <check-seal :res="checkInfo" :show="showCheck" :form="checkForm"></check-seal> -->
  </div>
</template>

<script>
  /* eslint-disable */
  import sealList from "./sealList.vue"
  import purposePc from "./purposePc.vue"
  import checkSeal from "./checkSeal.vue"
  export default {
    name: "seal",
    components: {
      "seal-list": sealList,
      "purpose-pc": purposePc,
      "check-seal": checkSeal,
    },
    data: function() {
      return {
        seal: {},
        isChoosed: false,
        posX: 0,
        posY: 0,
        showDelete: false,
        showList: false, //是否打开印章列表
        showPurpose: false, //是否打开意愿认证
        showCheck: false, //是否打开验签
        checkPurpuse: false, //意愿认证结果
        checkInfo: {
          isSuccess: true,
          message: "",
        }, //后端验签的信息
        checkForm: [], //前端校验表单
        // showIndex: "", // 展示移动和删除index
        showIcon: false,
        sealInfoList: [], // 合同上盖的章
        authRecordId: "",
        canDelete: true,
      }
    },
    props:{
      elecseal: Boolean,
      esignature: Boolean,
    },
    watch: {
      showList(val) {
        if (handler) {
          val
            ?
            handler.dialogShowLogic && handler.dialogShowLogic() :
            handler.dialogHideLogic && handler.dialogHideLogic()
        }
      },
      showPurpose(val) {
        if (handler) {
          val
            ?
            handler.dialogShowLogic && handler.dialogShowLogic() :
            handler.dialogHideLogic && handler.dialogHideLogic()
        }
      },
    },
    mounted: function() {
      // this.reFindSealList()
    },

    methods: {
      // 点击添加印章
      // chooseSeal: function () {
      //   this.showList = true
      // },
      chooseSeal: function() {
        if (this.isChoosed) {
          this.showDelete = !this.showDelete
        } else {
          this.showList = true
        }
      },
      deleteSeal: function() {
        this.posX = 0
        this.posY = 0
        this.seal = {}
        this.showDelete = false
        this.isChoosed = false
        handler && handler.deletedSeal && handler.deletedSeal()
      },
      submit: function() {
        if (!this.checkPurpuse) {
          this.showPurpose = true
        } else {
          this.checkSucc() //意愿认证成功后直接提交
        }
      },
      // 点击验签
      checkSeal: function(item) {
        this.showCheck = true //把这个写在接口回调
        this.checkInfo = {
          isSuccess: true,
          message: "",
        }
        this.checkSealOne(item)
      },
      // // 前端校验表单
      // checkSealForm: function (item) {
      //   this.checkForm = handler.checkForm(item.protectInfoList);
      //   if (this.checkForm.length == 0) {
      //     this.$nextTick(function () {
      //       item.lose = false;
      //     });
      //     if (item.newAdd) {
      //       return;
      //     } //新增签章未提交前，不进行后端验签
      //     this.checkSealServer(item); //前端验签通过校验后端
      //   } else {
      //     this.$nextTick(function () {
      //       item.lose = true;
      //     }); //验签失败给item添加失败标签
      //   }
      // },

      //单个验签
      checkSealOne: function name(item) {
        var that = this
        $.ajax({
          url: handler.severUrl + "/esignpro/rest/sign/verifySign2",
          type: "post",
          headers: {
            "Content-Type": "application/json;charset=utf8",
            "x-timevale-project-id": "1000000",
            "x-timevale-signature": "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
          },
          data: JSON.stringify({
            signatureList: [{
              signlogId: item.signlogId,
              timestampId: item.timestampId,
              businessProcessId: item.businessProcessId,
              signatureList: [{
                sealName: item.alias ? item.alias : item.sealName,
                userName: handler.userInfo.name,
                describe: item.describeData,
                sealId: item.sealRequestId,
              }, ],
            }, ],
          }),
          success: function(data) {
            if (data.errCode === 0) {
              var a = JSON.parse(JSON.stringify(data.data[0]))
              delete a.result
              delete a.sealId //2222
              if (data.data[0].result.success) {
                that.checkInfo = {
                  isSuccess: true,
                  message: "验签成功",
                  baseInfo: a,
                }
                console.log(that.checkInfo)
                handler.verifySuccess(item, that.checkInfo)
              } else {
                that.checkInfo = {
                  isSuccess: false,
                  message: data.data[0].result.message,
                  baseInfo: a,
                }
                console.log(that.checkInfo)
                handler.addLose(item, that.checkInfo) //修改
              }
            }
          },
          error: function(data) {
            console.log("error")
          },
        })
      },
      // 所有验签接口
      checkSealAll: function() {
        var that = this
        // if (item.newAdd) {
        //   return
        // }
        var list = []
        for (var i in this.sealInfoList) {
          var a = {
            signlogId: this.sealInfoList[i].signlogId,
            timestampId: this.sealInfoList[i].timestampId,
            businessProcessId: this.sealInfoList[i].businessProcessId,
            signatureList: [{
              sealName: this.sealInfoList[i].alias ?
                this.sealInfoList[i].alias :
                this.sealInfoList[i].sealName,
              userName: handler.userInfo.name,
              describe: this.sealInfoList[i].describeData,
              sealId: this.sealInfoList[i].sealRequestId,
            }, ],
          }
          list.push(a)
        }
        console.log("verify list", list)
        $.ajax({
          url: handler.severUrl + "/esignpro/rest/sign/verifySign2",
          type: "post",
          headers: {
            "Content-Type": "application/json;charset=utf8",
            "x-timevale-project-id": "1000000",
            "x-timevale-signature": "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
          },
          data: JSON.stringify({
            signatureList: list,
          }),
          success: function(data) {
            var errList = []
            for (let i in data.data) {
              if (!data.data[i].result.success) {
                for (let j in that.sealInfoList) {
                  if (data.data[i].sealId == that.sealInfoList[j].sealRequestId) {
                    handler.addLose(that.sealInfoList[j])
                  }
                }
              }
              if (data.data[i].result.success) {
                for (let j in that.sealInfoList) {
                  if (data.data[i].sealId == that.sealInfoList[j].sealRequestId) {
                    handler.verifySuccess(that.sealInfoList[j])
                  }
                }
              }
            }

            return data.data
            //返回失效的数组
          },
          error: function(data) {
            console.log("error")
          },
        })
      },

      //查询合同上已有签章
      reFindSealList: function() {
        var that = this
        $.ajax({
          url: handler.severUrl + "/V1/sealCoordinates/queryByBusinessProcessId",
          type: "post",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "x-timevale-project-id": "1000000",
            "x-timevale-signature": "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
          },
          data: {
            businessProcessId: handler.businessProcessId,
          },
          success: function(data) {
            if (data.errCode == 0) {
              that.sealInfoList = data.data
              if (that.sealInfoList.length > 0) {
                var signs = handler.setPos(data.data)
                that.sealInfoList = signs
                for (var i in signs) {
                  signs[i].uuid = that.getuuid()
                  signs[i].describeData = JSON.stringify(
                    handler.verifyData(JSON.parse(signs[i].describeData))
                  )
                  handler.run(signs[i])
                }
                console.log("待验证列表", signs)
                //渲染完毕调用loadSignature方法,用户决定是否验签
                handler.loadSignature()
              }
            }
          },
          error: function(data) {
            console.log("error")
          },
        })
      },
      //移动
      move: function(e) {
        var that = this
        var odiv = e.target.offsetParent //获取目标元素
        //算出鼠标相对元素的位置
        var disX = e.clientX - odiv.offsetLeft
        var disY = e.clientY - odiv.offsetTop
        console.log("offsetLeft", odiv.offsetLeft)
        document.onmousemove = function(e) {
          //鼠标按下并移动的事件
          //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
          var left = e.clientX - disX
          var top = e.clientY - disY
          //绑定元素位置到positionX和positionY上面
          that.posX = left
          that.posY = top
        }
        document.onmouseup = function(e) {
          document.onmousemove = null
          document.onmouseup = null
        }
      },
      save: function(e) {
        var that = this
        $.ajax({
          url: handler.severUrl + "/V1/sealCoordinates/saveCoordinates",
          type: "post",
          headers: {
            "Content-Type": "application/json;charset=utf8",
            "Access-Control-Allow-Methods": "GET, POST, PUT,DELETE,OPTIONS,PATCH",
            "x-timevale-project-id": "1000000",
            "x-timevale-signature": "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
          },
          data: JSON.stringify({
            sealRequestId: e.sealId,
            businessProcessId: e.businessProcessId,
            url: e.sealUrl,
            sealBase64: e.sealBase64,
            posX: that.posX,
            posY: that.posY,
            sealBase64: e.sealBase64,
            signlogId: e.signlogId,
            timestampId: e.timestampId,
            sealName: this.seal.alias ||
              this.seal.sealName ||
              handler.userInfo.name + "手绘", //1111
            userName: handler.userInfo.name,
            describeData: JSON.stringify(handler.setProtect()),
          }),
          success: function(data) {
            if (data.errCode === 0) {
              this.canDelete = false
              that.showDelete = false
              handler.submitHook && handler.submitHook(e.signlogId)
            }
          },
          error: function(data) {
            console.log("error")
          },
        })
      },
      // onDelete: function (item, index) {
      //   if (item.newAdd) {
      //     this.sealInfoList.splice(index, 1)
      //   }
      // },

      //意愿认证成功后提交签署
      // checkSucc: function () {
      //   var that = this
      //   this.checkSeal
      //   var list = [] //所有新增的印章信息
      //   var sealIdList = [] //新增印章id集合
      //   for (var i in this.sealInfoList) {
      //     this.sealInfoList[i].index = i
      //     if (this.sealInfoList[i].newAdd) {
      //       var a =
      //         this.sealInfoList[i].sealId ||
      //         this.sealInfoList[i].sealRequestId ||
      //         this.sealInfoList[i].sealUUID
      //       sealIdList.push({
      //         //todo 这里接口改了，原来的departmentId没了，下次改
      //         organizeId: this.sealInfoList[i].departmentId
      //           ? this.sealInfoList[i].departmentId
      //           : "", //有机构id就传机构id,没有就传用户id
      //         accountId: this.sealInfoList[i].departmentId
      //           ? ""
      //           : handler.userInfo.id,
      //         sealId: a,
      //         sealIndex: i, // 通过角标重新定位新增印章，将获取的验签信息塞回去用来验签
      //       })
      //       list.push(this.sealInfoList[i])
      //     }
      //   }
      //   this.reSubmit(sealIdList, list)
      //   //  for(var i in this.sealInfoList){
      //   //    this.sealInfoList[i].newAdd=false
      //   // }
      // },
      //意愿
      checkSucc: function(authRecordId) {
        this.reSubmit(authRecordId)
      },
      reSubmit: function(authRecordId) {
        if (JSON.stringify(this.seal) == "{}") {
          return
        }
        var list = [{
          sealBase64: this.seal.sealBase64 || "",
          sealId: this.seal.sealId || this.seal.sealUUID,
          sealUrl: this.seal.downloadUrl,
          sealHand: this.seal.ishand ? this.seal.ishand : false,
          type: this.seal.sealType == 1 ? 1 : 0,
          organizeId: this.seal.departmentId,
        }, ]
        // if(sealIdList.length==0){
        //   alert('请先选择印章')
        //    return
        // }
        var d = Date.now()
        d -= d % (60 * 1000)
        var that = this
        const data = JSON.stringify({
          accountUniqueId: handler.userInfo.uniqueId,
          accountId: handler.userInfo.id,
          businessProcessId: handler.businessProcessId,
          authRecordId: authRecordId, //
          certId: "",
          describe: handler.setProtect(),
          sealId: "", //
          sealList: list,
          signIp: "",
          organizeId: this.$refs.sealList.currentComp.departmentId,
          time: d,
          timestampSwitch: 1,
        })
        console.log(data)
        return $.ajax({
          url: handler.severUrl + "/esignpro/rest/sign/api/hashSignWithTimestamp2",
          type: "post",
          headers: {
            "Content-Type": "application/json;charset=utf8",
            "x-timevale-project-id": "1000000",
            "x-timevale-signature": "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
          },
          data: data,
          success: function(data) {
            if (data && data.data[0].success) {
              that.save(data.data[0]) //保存坐标
            } else {
              alert(data.data[0].message)
            }
            // that.canDelete = false
            //保存坐标
            // if (data.errCode == 0) {
            //   var sealList = data.data
            //   for (var j in sealList) {
            //     that.sealInfoList[sealList[j].sealIndex].signature =
            //       sealList[j].signature
            //     that.sealInfoList[sealList[j].sealIndex].newAdd = false
            //     that.sealInfoList[sealList[j].sealIndex].time = sealList[j].time
            //     that.sealInfoList[sealList[j].sealIndex].timestampId =
            //       sealList[j].timestampId
            //   }
            //   for (var i in list) {
            //     alert("提交成功")
            //     that.save(list[i]) //保存坐标
            //   }
            // } else {
            //   alert(data.msg)
            // }
          },
          error: function(data) {
            console.log("error")
          },
        })
      },
      mouseEnter: function() {
        this.showIcon = true
      },
      mouseleave: function() {
        this.showIcon = false
      },
      choosed: function(e) {
        if (!e) return
        this.isChoosed = true
        this.showList = false
        this.seal = e
        handler.chooseSeal(this.seal)
        // e.posX = handler.posX
        // e.posY = handler.posY
        // this.sealInfoList.push(e)
      },
      getuuid: function() {
        var s = []
        var hexDigits = "0123456789abcdef"
        for (var i = 0; i < 36; i++) {
          s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
        }
        s[14] = "4" // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-"

        var uuid = s.join("")
        this.uuid = uuid
        return uuid
      },
      getBase64: function(item) {
        var that = this
        let base64File
        $.ajax({
          url: handler.severUrl + "/V1/seals/getSealBase64",
          type: "get",
          async: false,
          headers: {
            "Access-Control-Allow-Methods": "GET, POST, PUT,DELETE,OPTIONS,PATCH",
            "x-timevale-project-id": "1000000",
            "x-timevale-signature": "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
          },
          data: {
            type: 0,//item.sealType == 1 ? 1 : 0 //只有内部章
            sealId: item.sealId ? item.sealId : item.sealRequestId,
          },
          success: function(data) {
            if (data.errCode === 0) {
              base64File = data.data && data.data.sealBase64
            }
          },
          error: function(data) {
            console.log("error")
          },
        })
        return base64File
      },
    },
  }
</script>

<style scoped>
  .seal {
    position: relative;
    width: 100px;
    height: 100px;
    background-color: #f8f8f8;
    border: 1px solid #e8e9ec;
    cursor: pointer;
    font-size: 14px;
    color: #316cf1;
  }

  .seal_choosed {
    position: absolute;
    width: 130px;
    height: 130px;
    background-color: #f8f8f8;
    border: 1px solid #e8e9ec;
    cursor: pointer;
  }

  .seal span {
    display: block;
    text-align: center;
  }

  .seal .sealIcon {
    font-size: 38px;
    font-weight: bold;
    margin-top: 10px;
  }

  .seal_choosed .sealImg {
    width: 130px;
    height: 130px;
  }

  .seal:hover {
    border: 1px solid #316cf1;
  }

  .sealDeleteButton {
    position: absolute;
    bottom: -20px;
    width: 130px;
    height: 20px;
    background-color: #316cf1;
    color: #fff;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    cursor: pointer;
  }

  .seal-container {
    position: relative;
  }

  /* .seal-container .move-div {
  position: absolute;
  height: 130px;
  width: 130px;
} */

  .move-div img {
    width: 130px;
    height: 130px;
  }

  .lose {
    position: absolute;
    width: 90px;
    height: 30px;
    line-height: 30px;
    top: 44px;
    left: 18px;
    font-size: 26px;
    text-align: center;
    color: gray;
    border: 5px solid;
  }
</style>
